import React, { useRef } from 'react';
import useClickAway from 'hooks/useClickAway';
import { useEffect } from 'react';

export interface IPopUp {
  open: boolean;
  setOpen?: (open: boolean) => void;
}

const PopUp: React.FC<IPopUp> = props => {
  const { open, setOpen } = props;

  const popUpRef = useRef();
  useClickAway(popUpRef, setOpen);

  return (
    <>
      {open && (
        <div className='pop-up__expand' ref={popUpRef}>
          <div className='pop-up__ul'>{props.children}</div>
        </div>
      )}
    </>
  );
};

export default PopUp;
